import Vue from 'vue'
import App from './App.vue'
import AppSettings from './store/util/appSettings'
import store from './store'
import router from './router'


Vue.config.productionTip = false

store.subscribe((mutation, state) => {
  localStorage.setItem(AppSettings.vuexLocalStorageName, JSON.stringify(state));
});


new Vue({
  el: '#app',
  router,
  store,
  beforeCreate() {
    this.$store.commit('initialiseStore');
  },
  render: h => h(App)
})
